export const container = `inline-flex items-center justify-between text-base-black font-bold text-sm px-3 pt-3`;
export const title = `text-sm data-[secondary="true"]:text-gray-400 data-[secondary="true"]:text-xs data-[secondary="true"]:font-medium`;
export const button = `ml-3 p-2 -my-1 -mx-2 self-start cursor-pointer`;
export const icon = `w-4 h-4`;
